// vue babel plugin doesn't support pragma replacement
import { mdx } from '@mdx-js/vue'
let h;
/* @jsx mdx */

export const metadata = {
  title: "Anagrams",
  author: {
    name: "James Parker",
    githubUsername: "James226"
  },
  created: "2020-07-21T09:00:00Z",
  timeLimit: 45,
  introduction: "In England, I used to waste hour upon hour doing newspaper crosswords. As crossword fans will know, English cryptic crosswords have a totally different feel to their American counterparts: most clues involve punning or word play, and there are lots of anagrams to work through. For example, a recent Guardian crossword had:\n\nMost unusual form of arrest (6)\n\nThe hint is the phrase ‘form of,’ indicating that we’re looking for an anagram. Sure enough ‘arrest’ has six letters, and can be arranged nicely into ‘rarest,’ meaning ‘most unusual.’ (Other anagrams include raster, raters, Sartre, and starer)",
  finalAnswer: "b996e7eaf8a2b199279360a76b18ab92c4191d84b37e1243c90cd1d7bb966567"
};

const layoutProps = {
  metadata
};
const MDXLayout = "wrapper"
function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h1>{`Tasks`}</h1>
    <h2>{`Task 1`}</h2>
    <alli-card class="mt-4 mb-8">
    <h2>anagram</h2>
    <small class="block mb-4 italic font-light">/ˈanəɡram/</small>
    <span>noun</span>
    <span class="block">a word, phrase, or name formed by rearranging the letters of another, such as 'spar', formed from 'rasp'.</span>
    </alli-card>
    <p>{`Write a program which generates all possible variants of the word 'spar' (i.e. asrp, pras, arsp)`}</p>
    <h2>{`Task 2`}</h2>
    <p>{`Enhance your previous solution to generate valid words using the word list provided below:`}</p>
    <p><a parentName="p" {...{
        "href": "https://github.com/dwyl/english-words/raw/master/words.zip"
      }}>{`https://github.com/dwyl/english-words/raw/master/words.zip`}</a></p>
    <h1>{`Final Puzzle`}</h1>
    <p>{`The final answer is an anagram of: 'het ecak si a eil'`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;

export default {
  name: 'Mdx',
  inject: {
    $mdxComponents: {
      default: () => () => ({})
    }
  },
  computed: {
    components() {
      return this.$mdxComponents()
    }
  },
  render(createElement) {
    h = mdx.bind({ createElement, components: this.components })
    return MDXContent({ components: this.components })
  }
}
   